<template>
  <div>
    <h1>发展历程</h1>
    <!-- <div style="margin-top: 20px;">
        <img loading="lazy" src="../../assets/images/companyStruct.jpg" alt="中科淞塔与研究院组织结构" title="中科淞塔与研究院组织结构" width="100%">
    </div> -->
	
	#
  </div>
</template>

<script>
export default {
  name: 'Structure'
};
</script>